import { blog as types } from 'pursuit/store/storeTypes';

const initialState = {
    blogs: [
        {
            title: 'First Blog',
            excerpt: 'Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
            link: '/blog/first-blog',
            image: '/img/home/Whiplash-Chiropractor-Arlington.webp'
        },
        {
            title: 'Second Blog',
            excerpt: 'Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
            link: '/blog/second-blog',
            image: '/img/home/Adrian-Chiropractor-Treating-Child-Patient-400x400.webp'
        },
        {
            title: 'Third Blog',
            excerpt: 'Consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.',
            link: '/blog/third-blog',
            image: '/img/home/3f.webp'
        }
    ],
};

const blogReducer = function(state = initialState, action) {
    switch(action.type) {
        case types.UPDATE_ENVS:
            return Object.assign({}, state, {
                'envs': action.data.envs,
            });
    }

    return state;
}

export default blogReducer;
